<template>
  <div id="app" @mousemove="moveEvent" @click="moveEvent">
    <remote-script src="https://scripts.easyliao.com/js/easyliao.js"></remote-script>
    <router-view></router-view>
    <dialog-tip :show="deleteDialog" title="温馨提示" @cancel="cancelDeleteDialog">
      <div class="tip_main">用户系统将还有5分钟登录过期！请点击确认操作延续！</div>
      <div class="tip_btn">
        <button @click="cancelDeleteDialog">确定</button>
      </div>
    </dialog-tip>
  </div>
</template>

<script>
      // document.writeln('<script type="text/javascript" charset="UTF-8" src="//scripts.easyliao.com/33395/64859.js"></sc'+'ript>');
  import Dialog_tip from "@/components/common/Dialog_tip";
  import {request} from "@/network/request";
  export default {
    name: 'App',
    data(){
      return {
        timmer: null,
        // 删除提示弹窗
        deleteDialog: false,
      }
    },
    components: {
      'dialog-tip': Dialog_tip
    },
    methods: {
      moveEvent(){
        let path = ['/login']
        clearTimeout(this.timmer2);
        this.loginTimer();
        if(!path.includes(this.$route.path)) { //如果不是登录页面的话页面停止进行30分钟后清空session
          clearTimeout(this.timmer);
          this.init();
        }
      },
      init(){
        this.timmer=setTimeout(()=>{
          //清除session
          sessionStorage.removeItem("JSESSIONID");
          sessionStorage.clear();
          //清除缓存
          // this.$cache.reset();
          //跳往登录页面
          // this.$router.push({
          //   path: "/login",
          // });
        },30*60*1000);//设置半小时清空session进入屏保

      },
      cancelDeleteDialog(){
        this.deleteDialog = false
        request({
          url: 'heart',
          method: 'options',
          header: {
            'Content-Type': 'application/json'
          },
        })
        clearTimeout(this.timmer2);
        this.loginTimer();
      },
      loginTimer(){
        this.timmer2 = setInterval(()=>{
          // this.deleteDialog = true
          request({
            url: 'heart',
            method: 'options',
            header: {
              'Content-Type': 'application/json'
            },
          })
        },10*60*1000)


      }

    },
    watch:{

    },
    async created(){
      const loading = this.$loading({
        lock: true,
        text: '加载中，请稍后',
        fullscreen: true
      })
      this.loginTimer()
      await this.$store.dispatch('updateRate')
      try {
        await this.$store.dispatch('updateStoreList')
      } catch (error) {
        console.log(error);
      }
      loading.close()
    }
  }
</script>

<style lang="scss">
  @import "./assets/css/base.css";
  .productStatusSelect{
    /* 隐藏多选框选中勾选样式 √ */
    .el-select-dropdown__item.selected::after {
      display: none;
    }
  }
  .tip_main{
    font-size: 15px;
    font-weight: bold;
    width: 500px;
    padding: 20px;
    color: black;
  }

  .tip_btn{
    display: flex;
    justify-content: space-between;
  }

  .tip_btn button{
    background-color: #19ACFD;
    color: white;
    padding: 10px 15px;
    border: none;
    outline: none;
    border-radius: 10px;
    margin: 10px 20px;
  }

  .tip_btn button:hover{
    cursor: pointer;
    opacity: .8;
  }
  .el-input__suffix-inner{
    display: inline !important;
  }
</style>
